import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import axios from 'axios';
import cssVars from 'css-vars-ponyfill';
import '@pagerduty/design-system/dist/standalone.ns.css';
import store from 'src/store';
// eslint-disable-next-line import/no-named-as-default
import App from 'src/components/App/App';
import getEnvironment from 'src/util/environment';
import { setAxiosDefaults } from 'src/util/axios';
import { init as initPretender } from 'src/pretender';
import config from 'src/config/app';

// Include CSS
import './styles/styles.module.css';

setAxiosDefaults(axios);

if (getEnvironment() === 'development') {
  initPretender();
}

// make css vars work in older browsers
cssVars({
  // set this to false to see the effects in Chrome
  onlyLegacy: true
});

// Set optimizely if not loaded on the page
window.optimizely = window.optimizely || [];

const RUNNER_KEY = `${config.APP_NAME}_runner`;
const DESTROYER_KEY = `${config.APP_NAME}_destroyer`;

global[RUNNER_KEY] = (opts, rootElementId) => {
  ReactDOM.render(
    <Provider store={store}><App className="apply-design-system" {...opts} /></Provider>,
    document.getElementById(rootElementId)
  );
};

global[DESTROYER_KEY] = (opts, rootElementId) => {
  ReactDOM.unmountComponentAtNode(document.getElementById(rootElementId));
};

if (!global[`_${config.APP_NAME}_embed`]) {
  global[RUNNER_KEY]({}, config.APP_NAME);
}
